import React from 'react';
import PropTypes from 'prop-types';
import { isArray, isObject, isString } from 'lib';

const List = ({
  items,
  itemComponent: ItemComponent,
  container: SContainer,
  itemProps = {},
}) => {
  if (isArray(items))
    return (
      <SContainer>
        {items?.map((item, i) => (
          <ItemComponent
            key={isString(item) ? item : i}
            item={item}
            {...itemProps}
          />
        ))}
      </SContainer>
    );

  if (isObject(items))
    return (
      <SContainer>
        {Object.keys(items)?.map((item, i) => (
          <ItemComponent
            key={i}
            item={item}
            value={items[item]}
            {...itemProps}
          />
        ))}
      </SContainer>
    );
};

List.propTypes = {
  items: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  itemComponent: PropTypes.func,
  container: PropTypes.object,
  itemProps: PropTypes.object,
};

export default List;
